import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Roles } from '../auth/roles.enum';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationService {

  constructor(private auth: AuthService) { }

  /**
   * To check if current user has the specified permission
   * @param permission - permission to check
   * @param is_role_specific - whether the permission is role specific
   * @param role - role to check if is_role_specific is true
   * @returns - true if current user has the permission, false otherwise
   */
  hasPermission(permission: string, is_role_specific: boolean = false, role: string = Roles.SUPER_ADMIN): boolean {
    if (is_role_specific) {
      return this.auth.hasRole(role) && this.auth.hasPermission(permission);
    }
    return this.auth.hasPermission(permission);
  }

  /**
   * To check if current user has the specified role
   * @param role - role to check
   * @returns - true if current user has the role, false otherwise
   */
  hasRole(role: string): boolean {
    return this.auth.hasRole(role);
  }

  /**
   * To check if current user is a super admin
   * @returns - true if current user is a super admin, false otherwise
   */
  isSuperAdmin(): boolean {
    return this.auth.hasRole(Roles.SUPER_ADMIN);
  }

  /**
   * To check if the specified user has any of the specified roles
   * @param roles - roles to check
   * @param userRole - user role to check
   * @returns - true if the user has any of the roles, false otherwise
   */
  userHasAnyRole(roles: string[], userRole: string): boolean {
    return roles.includes(userRole);
  }
}
